export enum EAgentRegistrationStep {
  BASE_FORM = 'BASE_FORM',
  COMMUNICATION_METHOD = 'COMMUNICATION_METHOD',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
